import { Component, computed, inject } from "@angular/core";
import { rxResource } from "@angular/core/rxjs-interop";
import { RouterLink } from "@angular/router";
import { FeatureFlagDirective } from "@dcc/shared/feature-flags/ui";
import { RichTextContainerComponent } from "@dcc/shared/rich-text-output-ui";
import { VdsAnchorButtonComponent, VdsIconButtonComponent } from "@cce/design-system/button";
import { VdsHeaderComponent } from "@cce/design-system/header";
import { VdsIconComponent } from "@cce/design-system/icon";
import { VdsInlineAlert } from "@cce/design-system/inline-alert";
import { VdsMenu, VdsMenuItem, VdsMenuTrigger } from "@cce/design-system/menu";
import { SpinnerComponent } from "@cce/design-system/spinner";
import { VdsTooltipDirective } from "@cce/design-system/tooltip";
import { AuthService } from "@dcc/vestas-online/auth/data-access";
import { TermsClient, UserStore } from "@dcc/vestas-online/data-access";
import { User } from "@dcc/vestas-online/domain";
import { LogoComponent } from "@dcc/vestas-online/shared/ui";
import { LanguageMenuComponent } from "@dcc/vestas-online/shared/ui-language-dropdown";
import { TranslocoDirective } from "@jsverse/transloco";
import { map } from "rxjs";
import { TosFormComponent } from "./tos-form/tos-form.component";
import { TosStore } from "./tos.store";

const TERMS_KEY = "PLATFORM";

@Component({
    selector: "vo-shell-tos-page",
    templateUrl: "./tos.component.html",
    host: {
        class: "u-contain--layout-size-style absolute inset-0 z-0 flex flex-col overflow-hidden print:static print:z-auto print:block print:overflow-auto"
    },
    providers: [TosStore],
    imports: [
        LanguageMenuComponent,
        VdsMenu,
        VdsMenuTrigger,
        VdsMenuItem,
        RouterLink,
        VdsHeaderComponent,
        TranslocoDirective,
        TosFormComponent,
        VdsAnchorButtonComponent,
        VdsIconComponent,
        VdsInlineAlert,
        SpinnerComponent,
        LogoComponent,
        RichTextContainerComponent,
        VdsIconButtonComponent,
        VdsTooltipDirective,
        FeatureFlagDirective
    ]
})
export class TosComponent {
    private termsClient = inject(TermsClient);
    private userStore = inject(UserStore);
    private authService = inject(AuthService);

    protected readonly store = inject(TosStore);

    // Legacy (non-consent-platform) path
    protected readonly legacyTermsResource = rxResource({
        stream: () => this.termsClient.getTermById(TERMS_KEY).pipe(map((term) => ({ content: term.content })))
    });
    protected readonly legacyShouldAcceptTerms = computed(() => !(this.userStore.user()?.termsAccepted ?? false));

    readonly user = this.userStore.user;
    readonly isLoading = this.userStore.loading;
    readonly updating = this.store.updating;

    legacyTermsAccepted(): void {
        this.userStore.acceptUserTerms();
    }

    changeUserLanguage(locale: { id: string; value: string }, user: User): void {
        this.userStore.updateUser({ ...user, language: locale.id });
    }

    logout(): void {
        void this.authService.logout();
    }
}
